import MixedMedia from '@klv/molecules/mixed-media';
import * as s from './styles';
import type { IMediaCustomPricingContent } from './types';

const MediaCustomContent = ({ mediaAlignment, mixedMedia }: IMediaCustomPricingContent) => (
  <s.PricingCustomGridMedia $mediaAlignment={mediaAlignment}>
    <MixedMedia mixedMedia={mixedMedia} />
  </s.PricingCustomGridMedia>
);

export default MediaCustomContent;
